module.exports = __webpack_public_path__ + "static/img/mjqh5.de01565.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjqh5.png
// module id = V++p
// module chunks = 0